export function level(v) {
    if (v < -0.3)
        return 'low';
    if (v > 0.3)
        return 'high';
    return 'mid';
}
/**
 * Map a (physical × emotional × intellectual) level triple to one of a
 * curated set of advice keys. Patterns that share advice point to the same
 * key — there are 27 possible triples but only ~12 distinct advice texts.
 */
const ADVICE_MAP = {
    // All high — best day kind of energy.
    'high-high-high': 'all_high',
    // Mostly high.
    'high-high-mid': 'mostly_high',
    'high-mid-high': 'mostly_high',
    'mid-high-high': 'mostly_high',
    // Single-axis high.
    'high-mid-mid': 'physical_strong',
    'high-mid-low': 'physical_strong',
    'mid-high-mid': 'emotional_strong',
    'mid-high-low': 'emotional_strong',
    'mid-mid-high': 'mind_strong',
    'low-mid-high': 'mind_strong',
    // Mid all around.
    'mid-mid-mid': 'neutral_day',
    // Mid + one low.
    'low-mid-mid': 'physical_tired',
    'mid-low-mid': 'emotional_tender',
    'mid-mid-low': 'mind_tired',
    // Mostly low.
    'low-low-mid': 'mostly_low',
    'low-mid-low': 'mostly_low',
    'mid-low-low': 'mostly_low',
    // All low.
    'low-low-low': 'all_low',
    // Mixed extremes.
    'high-low-mid': 'mixed_extremes',
    'low-high-mid': 'mixed_extremes',
    'high-low-high': 'mixed_extremes',
    'low-high-low': 'mixed_extremes',
    'low-low-high': 'mind_alone',
    'high-low-low': 'body_alone',
};
const ADVICE_TEXTS = {
    ru: {
        all_high: 'Звёздный день. Берись за то, что давно откладывал — и физика, и сердце, и голова сегодня с тобой.',
        mostly_high: 'Очень хороший день. Энергия идёт ровно, делай то, что важно — поддержки изнутри много.',
        physical_strong: 'Тело сегодня в форме — спорт, тяжёлая работа, физическая активность зайдут особенно хорошо.',
        emotional_strong: 'Эмоциональный пик. Хорошо для разговоров от сердца, творчества, важных встреч.',
        mind_strong: 'Голова работает на максимум. День для текстов, учёбы, сложных решений и аналитики.',
        neutral_day: 'Ровный день без всплесков. Хорошо подходит для рутины и поддерживающих дел.',
        physical_tired: 'Тело просит отдыха. Перенеси физнагрузки на завтра, побольше спи и пей воду.',
        emotional_tender: 'Эмоции сегодня шаткие. Не доверяй первой реакции, не принимай больших решений на горячую голову.',
        mind_tired: 'Голова сегодня медленнее обычного. Не насилуй её — отложи сложное чтение и принятие решений.',
        mostly_low: 'День низких циклов. Будь к себе мягче, снизь обороты, не требуй от себя многого.',
        all_low: 'Все циклы в минусе — редкое сочетание. Хороший день, чтобы ничего не планировать и побыть в режиме восстановления.',
        mixed_extremes: 'День противоречий: что-то рвётся вверх, что-то проседает. Слушай тело и не насилуй то, что устало.',
        mind_alone: 'Голова в плюсе, но тело и сердце отстают. Хорошо для текстов и анализа, плохо для активности и встреч.',
        body_alone: 'Тело сильное, но эмоции и голова в минусе. Двигайся, дай выход физической энергии — внутреннее подтянется.',
    },
    en: {
        all_high: "A star day. Take on what you've been putting off — body, heart, and head are all with you.",
        mostly_high: 'Very good day. Energy flows evenly; do what matters — internal support is plentiful.',
        physical_strong: 'Body is in form today — sports, heavy work, physical activity will land especially well.',
        emotional_strong: 'Emotional peak. Good for heart-to-heart talks, creativity, important meetings.',
        mind_strong: 'Head is at peak. A day for writing, learning, complex decisions, analytical work.',
        neutral_day: 'Even day with no spikes. Suits routine and supporting tasks well.',
        physical_tired: 'Body asks for rest. Move physical work to tomorrow, sleep more, drink water.',
        emotional_tender: "Emotions are shaky today. Don't trust the first reaction, don't make big decisions hot-headed.",
        mind_tired: "Head is slower than usual. Don't push it — defer complex reading and decisions.",
        mostly_low: "A low-cycle day. Be softer with yourself, drop the pace, don't demand much.",
        all_low: 'All cycles in the minus — rare combination. A good day to plan nothing and be in recovery mode.',
        mixed_extremes: 'A contradictory day: something rushes up, something sags. Listen to the body, don\'t force what\'s tired.',
        mind_alone: 'Head in plus but body and heart lag. Good for writing and analysis, bad for activity and meetings.',
        body_alone: 'Body strong but emotions and head in minus. Move, let physical energy out — the inner will follow.',
    },
};
export function biorhythmAdvice(values, lang) {
    const triple = `${level(values.physical)}-${level(values.emotional)}-${level(values.intellectual)}`;
    const key = ADVICE_MAP[triple] ?? 'neutral_day';
    return {
        key,
        text: ADVICE_TEXTS[lang][key],
    };
}
//# sourceMappingURL=advice.js.map